import React from "react";
import ButtonNoIcon from "./Buttons/ButtonNoIcon";

import styles from "./ReviewKCard.module.css";

const ReviewKCard = function (props) {
  return (
    <div className={styles.scene}>
      <div className={`${styles.card} ${props.className}`}>
        <div className={styles.front}>
          <div className={styles["text-container"]}>
            <p className={styles.result}>{props.data.result}</p>
          </div>
        </div>
        <div className={styles.back}>
          <div className={styles["img-container"]}>
            <img className={styles.img} src={props.data.imgUrl} alt="" />
          </div>
          <div className={styles["text-container"]}>
            <p className={styles["result-back"]}>{props.data.result}</p>
            <p className={styles.query}>{props.data.query}</p>
          </div>
          <div className={styles.controls}>
            <ButtonNoIcon
              className={`${styles["control-btn"]} ${styles["btn-submit"]}`}
              onClick={props.onSubmitHandler}
            >
              Got it
            </ButtonNoIcon>
            <ButtonNoIcon
              className={`${styles["control-btn"]} ${styles["btn-retry"]}`}
              onClick={props.onRetryHandler}
            >
              Retry
            </ButtonNoIcon>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewKCard;
